import { render } from "./PendidikanLaporan.vue?vue&type=template&id=3b07c34f"
import script from "./PendidikanLaporan.vue?vue&type=script&lang=js"
export * from "./PendidikanLaporan.vue?vue&type=script&lang=js"

import "./PendidikanLaporan.vue?vue&type=style&index=0&id=3b07c34f&lang=css"
import "./PendidikanLaporan.vue?vue&type=style&index=1&id=3b07c34f&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__